module.exports = __webpack_public_path__ + "img/fma-assurances.4c7f8f30.png";